// extracted by mini-css-extract-plugin
module.exports = {"button--default":"RSKantanIconButtonAnchor_button--default__6gzG3","icon-wrapper":"RSKantanIconButtonAnchor_icon-wrapper__vavmE","spin":"RSKantanIconButtonAnchor_spin__Zoa__"};